// Sequence JS

document.addEventListener('DOMContentLoaded', function () {
  // --- Utility Functions ---
  function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function hasCookieConsent() {
    return !!getCookie("wow_cookie_consent");
  }

  function hasSeenLocationThisSession() {
    return !!sessionStorage.getItem("wow_location_popup_shown");
  }

  function hasSeenSubscribeThisSession() {
    return !!sessionStorage.getItem("wow_subscribe_popup_shown");
  }

  function waitForEvent(name) {
    return new Promise(resolve => {
      window.addEventListener(name, resolve, { once: true });
    });
  }

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function hideAllPopups() {
    const popups = [
      document.getElementById("popupOverlayCookies"),
      document.getElementById("popupOverlayLocation"),
      document.getElementById("popupOverlaySubscribeDiscount")
    ];
    popups.forEach(el => {
      if (el) el.style.display = 'none';
    });
  }

  // --- Main Popup Flow ---
  async function runPopupSequence() {
    // STEP 1: Cookie Consent
    if (!hasCookieConsent()) {
      hideAllPopups();
      showCookiePopup();
      await waitForEvent('wowCookieAccepted');
    }

    // STEP 2: Location popup after scrolling 15%
    await wait(500);
    if (!hasSeenLocationThisSession()) {
      await waitForScrollTrigger(0.15);
      sessionStorage.setItem("wow_location_popup_shown", "true");
      hideAllPopups();
      showLocationOverlay();
      const locPopup = document.getElementById("locationPopup");
      if (locPopup) locPopup.style.display = "block";
      await waitForEvent('wowLocationHandled');
    }

    // STEP 3: Subscribe popup via exit-intent OR 20s timeout
    if (!hasSeenSubscribeThisSession()) {
      await waitForSubscribeTrigger();
      triggerSubscribePopupOnce();
      await waitForEvent('wowSubscribeClosed');
    }
  }

  // --- Scroll trigger helper ---
  function waitForScrollTrigger(percentage = 0.35) {
    return new Promise(resolve => {
      function checkScroll() {
        const scrolled = window.scrollY;
        const triggerPoint = document.body.scrollHeight * percentage;
        if (scrolled > triggerPoint) {
          window.removeEventListener('scroll', checkScroll);
          resolve();
        }
      }
      window.addEventListener('scroll', checkScroll);
    });
  }

  // --- Subscribe trigger (exit-intent OR timeout) ---
  function waitForSubscribeTrigger() {
    return new Promise(resolve => {
      let resolved = false;

      const timer = setTimeout(() => {
        if (!resolved) {
          resolved = true;
          cleanup();
          resolve();
        }
      }, 20000);

      function handleExitIntent(e) {
        if (
          !hasSeenSubscribeThisSession() &&
          e.toElement === null &&
          e.relatedTarget === null
        ) {
          if (!resolved) {
            resolved = true;
            cleanup();
            resolve();
          }
        }
      }

      function cleanup() {
        clearTimeout(timer);
        document.removeEventListener('mouseout', handleExitIntent);
      }

      document.addEventListener('mouseout', handleExitIntent);
    });
  }

  // --- Trigger ONLY discount popup ---
  function triggerSubscribePopupOnce() {
    sessionStorage.setItem('wow_subscribe_popup_shown', 'true');
    hideAllPopups();
    window.dispatchEvent(new Event('triggerSubscribePopupDiscount'));
  }

  // --- Track visit count ---
  (function trackReturningUser() {
    let visits = parseInt(localStorage.getItem('wow_visit_count') || '0', 10);
    visits += 1;
    localStorage.setItem('wow_visit_count', visits);
  })();

  runPopupSequence();
});

// --- Event listener for the only popup ---
window.addEventListener('triggerSubscribePopupDiscount', function () {
  document.getElementById('popupOverlaySubscribeDiscount').style.display = 'block';
});
